export enum E_APP_ENV {
  DEVELOPMENT = 'development',
  TESTING = 'testing',
  PRODUCTION = 'production',
}

export enum E_TaskQueue {
  MEETING_PREP = 'meeting_prep',
}

export enum E_Workflow {
  MeetingPrep = 'meeting-prep',
  FridayPodcast = 'friday-podcast',
}

export type T_QueuedTaskType = {
  type: E_TaskQueue.MEETING_PREP;
  payload: string;
  retryCount: number;
};

export enum ESubscriptionPlan {
  Free = 'free',
  Pro = 'pro',
}

export enum ESubscriptionPlanFeatures {
  EmailProcessing = 'email-processing',
  Drafts = 'drafts',
  MeetingPrep = 'meeting-prep',
  MeetingBot = 'meeting-bot',
  Podcast = 'podcast',
  SocialGraph = 'social-graph',
}


export enum E_GraphQlErrorCode {
  GRAPHQL_PARSE_FAILED = 'GRAPHQL_PARSE_FAILED',
  GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  FORBIDDEN = 'FORBIDDEN',
  PERSISTED_QUERY_NOT_FOUND = 'PERSISTED_QUERY_NOT_FOUND',
  PERSISTED_QUERY_NOT_SUPPORTED = 'PERSISTED_QUERY_NOT_SUPPORTED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}

export enum E_MeetingPrepAction {
  PreRun = 'pre-run',
  PrepOneMeeting = 'prep-one-meeting',
  SendPrep = 'send-prep',
}